import { LabelUrlDTO } from '.';
import { ResponseDTO } from './response-dto';

export interface SaveUserContextRoleScopeProfileResponseDTO extends ResponseDTO {
    idbApps?: string;
    idbAppsList?: LabelUrlDTO[];
    roleStatus?: string;
    roleStatusLabel?: string;
    userStatus?: string;
    userStatusLabel?: string;
    canSendAccountActivationLink?: boolean;
}
